import React from "react";
import { Typography, Card } from "antd";
import { MailOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

export default function ClientOutlookAccess() {
  return (
    <div style={{ padding: "24px", background: "#f5f6fa", minHeight: "100vh" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
        <div style={{
          width: 42, height: 42, borderRadius: 10,
          background: "linear-gradient(135deg, #f093fb, #f5576c)",
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <MailOutlined style={{ color: "#fff", fontSize: 20 }} />
        </div>
        <div>
          <Title level={4} style={{ margin: 0 }}>Client Outlook</Title>
          <Text type="secondary">Manage client email access and assignments</Text>
        </div>
      </div>
      <Card
        bordered={false}
        style={{
          borderRadius: 16,
          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
          textAlign: "center",
          padding: "60px 24px",
        }}
      >
        <div style={{ fontSize: 48, marginBottom: 16 }}>🚧</div>
        <Title level={4} style={{ color: "#8c8c8c" }}>Coming Soon</Title>
        <Text type="secondary">
          Client Outlook management will be available in a future update.
        </Text>
      </Card>
    </div>
  );
}
